export default __webpack_public_path__ + "static/media/d-9.8c83c289.png";